export type Locale = "ru" | "ro";

const STORAGE_KEY = "sp_locale";

export const getStoredLocale = (): Locale => {
  const v = localStorage.getItem(STORAGE_KEY);
  return v === "ro" ? "ro" : "ru";
};

export const setStoredLocale = (locale: Locale) => {
  localStorage.setItem(STORAGE_KEY, locale);
};

type Dict = Record<string, string>;

const ru: Dict = {
  "app.logout": "Выйти",
  "app.devices": "Устройства",
  "app.users": "Пользователи",
  "login.title": "Вход",
  "login.email": "Логин",
  "login.password": "Пароль",
  "login.token": "Токен",
  "login.submit": "Войти",
  "login.emailRequired": "Введите логин",
  "login.passwordRequired": "Введите пароль",
  "login.tokenRequired": "Выберите файл токена",
  "login.invalidCredentials": "Неверный логин или пароль",
  "login.invalidToken": "Неверный токен доступа",
  "login.error": "Ошибка входа",
  "hubs.title": "Hub",
  "hubs.empty": "Hub не найдены",
  "hubs.select": "Выбрать",
  "hubs.comment": "Комментарий",
  "hubs.asiCount": "ASI",
  "asi.title": "ASI",
  "asi.empty": "ASI не найдены",
  "asi.select": "Открыть",
  "asi.back": "Назад к Hub",
  "asi.settings": "Назначения людей",
  "asi.name": "Название",
  "asi.comment": "Комментарий",
  "asi.zones": "Зоны",
  "asi.people": "Люди",
  "asi.group": "Зона",
  "asi.selectPeople": "Выберите людей",
  "asi.save": "Сохранить",
  "asi.saveSuccess": "Изменения сохранены",
  "asi.saveError": "Изменения не сохранены",
  "asi.loading": "Загрузка...",
  "asi.notFound": "Устройство не найдено",
  "asi.zonesReadonly": "Зоны (только просмотр)",
  "users.create": "Создать пользователя",
  "users.role.admin": "Admin — полный доступ",
  "users.role.manager": "Менеджер — устройства и пользователи",
  "users.role.operator": "Оператор — устройства",
  "users.col.createdAt": "Регистрация",
  "users.col.login": "Логин",
  "users.col.role": "Роль",
  "users.col.actions": "Действия",
  "users.delete": "Удалить",
  "users.deleteTitle": "Удаление",
  "users.deleteConfirm": "Вы действительно хотите удалить пользователя?",
  "users.cancel": "Отменить",
  "users.empty": "Пользователи не найдены",
  "users.roleLabel.admin": "Admin",
  "users.roleLabel.manager": "Менеджер",
  "users.roleLabel.operator": "Оператор",
  "lang.ru": "Русский",
  "lang.ro": "Română",
};

const ro: Dict = {
  "app.logout": "Ieșire",
  "app.devices": "Dispozitive",
  "app.users": "Utilizatori",
  "login.title": "Autentificare",
  "login.email": "Login",
  "login.password": "Parolă",
  "login.token": "Token",
  "login.submit": "Autentificare",
  "login.emailRequired": "Introduceți loginul",
  "login.passwordRequired": "Introduceți parola",
  "login.tokenRequired": "Selectați fișierul token",
  "login.invalidCredentials": "Login sau parolă incorectă",
  "login.invalidToken": "Token de acces invalid",
  "login.error": "Eroare de autentificare",
  "hubs.title": "Hub",
  "hubs.empty": "Nu există Hub",
  "hubs.select": "Selectați",
  "hubs.comment": "Comentariu",
  "hubs.asiCount": "ASI",
  "asi.title": "ASI",
  "asi.empty": "Nu există ASI",
  "asi.select": "Deschide",
  "asi.back": "Înapoi la Hub",
  "asi.settings": "Alocări persoane",
  "asi.name": "Denumire",
  "asi.comment": "Comentariu",
  "asi.zones": "Zone",
  "asi.people": "Persoane",
  "asi.group": "Zonă",
  "asi.selectPeople": "Selectați persoanele",
  "asi.save": "Salvare",
  "asi.saveSuccess": "Modificările au fost salvate",
  "asi.saveError": "Modificările nu au fost salvate",
  "asi.loading": "Se încarcă...",
  "asi.notFound": "Dispozitivul nu a fost găsit",
  "asi.zonesReadonly": "Zone (doar vizualizare)",
  "users.create": "Creați utilizator",
  "users.role.admin": "Admin — acces complet",
  "users.role.manager": "Manager — dispozitive și utilizatori",
  "users.role.operator": "Operator — dispozitive",
  "users.col.createdAt": "Înregistrare",
  "users.col.login": "Login",
  "users.col.role": "Rol",
  "users.col.actions": "Acțiuni",
  "users.delete": "Șterge",
  "users.deleteTitle": "Ștergere",
  "users.deleteConfirm": "Sigur doriți să ștergeți utilizatorul?",
  "users.cancel": "Anulare",
  "users.empty": "Utilizatorii nu au fost găsiți",
  "users.roleLabel.admin": "Admin",
  "users.roleLabel.manager": "Manager",
  "users.roleLabel.operator": "Operator",
  "lang.ru": "Русский",
  "lang.ro": "Română",
};

const dictionaries: Record<Locale, Dict> = { ru, ro };

export const translate = (locale: Locale, key: string): string =>
  dictionaries[locale][key] || dictionaries.ru[key] || key;
